function headerWithUnitTemplate(unit, hasTooltip = false) {
  return (
    '<div class="ag-cell-label-container" role="presentation">' +
    '    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
    '    <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
    '        <div class="text-center" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap">' +
    '            <span ref="eText" class="ag-header-cell-text" role="columnheader"></span><br>' +
    (unit ? "            <span>(" + unit + ")</span>" : "") +
    "        </div>" +
    (hasTooltip
      ? '        <svg width="12px" height="12px" style="margin-left: 5px; fill: #b0b0b2; stroke: none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">' +
        '            <path class="cls-1" d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM10.18,5.64a.91.91,0,0,1,.91-.91H12a.91.91,0,0,1,.91.91v.91a.9.9,0,0,1-.91.9h-.91a.9.9,0,0,1-.91-.9ZM16,19H8V17h3V11H9V9h4v8h3Z"/>' +
        "        </svg>"
      : "") +
    '        <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
    '        <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
    '        <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
    '        <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
    '        <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
    "    </div>" +
    "</div>"
  );
}

export { headerWithUnitTemplate };
